import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import { initAnalytics } from "./common/services/analytics";
import { captureFirstTouchAttribution } from "./common/services/analytics/attribution";
import "./index.css";
import { initSentry } from "./sentry";

initSentry();
captureFirstTouchAttribution();
initAnalytics();

createRoot(document.getElementById("root")!).render(
	// @ts-ignore - react-helmet-async types may lag behind React versions.
	<HelmetProvider>
		<App />
	</HelmetProvider>,
);
